// extracted by mini-css-extract-plugin
export default {"ReviewAttribution":"ReviewAttribution_ReviewAttribution__4Uc2-"};